window.app = window.app || {};

window.app.resourcesSearch = {
    el: {
        body: document.querySelector('body'),
        section: document.querySelector('.mt-resources-search'),
        searchBox: document.querySelector('.mt-rs-box'),
        searchForm: document.querySelector('.mt-rs-box__form'),
        searchInput: document.querySelector('.mt-rs-box__form input'),
        searchResults: document.querySelector('.mt-rs-box__results'),
        searchElements: [],
        searchClose: document.querySelector('.mt-rs-box__form-btn--close')
    },

    clearSearch: function() {
        const _this = this;
        _this.el.searchInput.value = '';
        _this.el.searchBox.classList.remove('active');
    },

    search: function(query = '') {
        const _this = this;
        let resultsCount = 0;
        if (query.length === 0) return;

        _this.el.searchResults.innerHTML = '';
        _this.el.searchElements = document.querySelectorAll('.mt-resource-item');
        _this.el.searchElements.forEach(element => {
            const elementText = element.textContent.toLowerCase();
            const searchQuery = query.toLowerCase();

            if (elementText.includes(searchQuery)) {
                const elementData = {
                    authors: element.querySelector('.mt-resource-item__authors')?.innerText || '',
                    title: element.querySelector('.mt-resource-item__title')?.innerText || '',
                    link: element.querySelector('.mt-resource-item__btn')?.href || ''
                };
                if (elementData.title === '' || elementData.link === '') return;

                const result = document.createElement('a');
                result.classList = 'mt-rs-box__result';
                result.setAttribute('target', '_blank');
                result.setAttribute('href', elementData.link);

                const resultTitle = document.createElement('p');
                resultTitle.classList = 'mt-rs-box__result-title';
                resultTitle.innerHTML = elementData.title;

                let resultAuthors;
                if (elementData.authors !== '') {
                    resultAuthors = document.createElement('p');
                    resultAuthors.classList = 'mt-rs-box__result-authors';
                    resultAuthors.innerHTML = elementData.authors;
                }

                // Additional DL events
                result.addEventListener('click', () => {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: 'search',
                      link_text: elementData.title,
                      search_term: query
                    });
                });
               
                resultAuthors && result.appendChild(resultAuthors);
                result.appendChild(resultTitle);
                _this.el.searchResults.appendChild(result);

                resultsCount++;
            }
        });

        // No results
        if (resultsCount === 0) {
            const message = document.createElement('p');
            message.innerHTML = _this.el.searchResults.dataset.tEmpty.replace('{{terms}}', `<strong>${query}</strong>`);
            _this.el.searchResults.appendChild(message);
        }
    },

    init: function () {
        const _this = this;
        if (!_this.el.section) return;

        // Sticky
        let lastScrollTop = 0;
        const stickyNav = () => {
            const sectionPosition = _this.el.section.getBoundingClientRect().top + document.documentElement.scrollTop;
            const currentScrollTop = window.scrollY;

            _this.el.section.classList.toggle('sticky', currentScrollTop > sectionPosition);
            if (!_this.el.searchBox.classList.contains('active')) {
                _this.el.section.classList.toggle('sticky-visible', currentScrollTop < lastScrollTop && _this.el.section.classList.contains('sticky'));
            } 

            lastScrollTop = currentScrollTop;
        };
        stickyNav();
        window.addEventListener('scroll', () => stickyNav());

        // Search
        if (!_this.el.searchBox || !_this.el.searchInput) return;
        _this.el.searchInput.addEventListener('input', e => {
            const query = e.target.value.trim();
            if (query.length >= 3) {
                _this.search(query);
                _this.el.searchBox.classList.add('active');
            } else {
                _this.el.searchBox.classList.remove('active');
            }
        });

        _this.el.searchForm.addEventListener('submit', e => {
            e.preventDefault();
        });

        _this.el.searchClose?.addEventListener('click', e => {
            e.preventDefault();
            _this.clearSearch();
        });

        _this.el.body.addEventListener('click', e => {
            if (_this.el.searchBox.classList.contains('active') && !e.target.closest('.mt-resources-search'))
            _this.clearSearch();
        });
    }
}

document.addEventListener('DOMContentLoaded', () => window.app.resourcesSearch.init());